import type {SearchParams} from '@/modules/common/context/QueryParams/models';
import type {
  EventAction,
  EventActionCreator,
  EventHandler,
} from '@/redux/middleware/googleTagManager/types';
import type {Page} from '@/types';

import {EVENT_PAGE_VIEW} from '@/redux/middleware/googleTagManager/actionTypes';
import {buildVirtPath} from '@/redux/middleware/googleTagManager/utils/virtPath';

type Payload = {
  page: Page;
  searchParams: SearchParams;
};

type Action = EventAction<Payload>;

type Event = {
  virtpath: string;
  event: string;
  event_action: string;
};

export const action: EventActionCreator<Action, Payload> = (payload) => ({
  type: EVENT_PAGE_VIEW,
  payload,
});

export const handler: EventHandler<Action, Event> = (eventAction) => {
  const {page, searchParams} = eventAction.payload;
  const travelType = searchParams.travelType;

  return {
    virtpath: buildVirtPath({
      page,
      travelType,
    }),
    event: 'page_view',
    event_action: 'spa_pageview',
  };
};
